import { render, staticRenderFns } from "./BuyLabelPopup.vue?vue&type=template&id=a55d27f8&scoped=true"
import script from "./BuyLabelPopup.vue?vue&type=script&lang=js"
export * from "./BuyLabelPopup.vue?vue&type=script&lang=js"
import style0 from "./BuyLabelPopup.vue?vue&type=style&index=0&id=a55d27f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55d27f8",
  null
  
)

export default component.exports